import {
  getMusclesFiltersExercisesSelect,
  MUSCLE_TO_KEY
} from '@gymaholic/packages'

/**
 * @param searchParamsStr
 * @returns {(function(*, *): (undefined|string))|*}
 */
export default function handleMusclesSyncReduxToUrlAction ({ searchParamsStr }) {
  return (dispatch, getState) => {
    const musclesFilters = getMusclesFiltersExercisesSelect(getState())

    let muscleQueryParam = ''
    if (!musclesFilters.length) {
      return searchParamsStr
    }

    musclesFilters.map((muscleId, index) => {
      const muscleName = MUSCLE_TO_KEY[muscleId].toLowerCase().replace(/_/g, ' ')
      if (index === 0) {
        muscleQueryParam = muscleQueryParam + muscleName
      } else {
        muscleQueryParam = muscleQueryParam + `,${muscleName}`
      }
      return null
    })

    if (searchParamsStr.length > 0) {
      return searchParamsStr + `&muscles=${muscleQueryParam}`
    }

    return searchParamsStr + `muscles=${muscleQueryParam}`
  }
}
